import request from '@/utils/request'

export function findByAccount(params) {
  return request({
    url: '/admin/store/findByAccount',
    method: 'get',
    params: params
  })
}

export function findStoreById(params) {
  return request({
    url: '/admin/store/findById',
    method: 'get',
    params: params
  })
}


/**
 * 查询店铺的vip成员
 */
export function findVipUser(params) {
  return request({
    url: '/admin/store/findVipUser',
    method: 'get',
    params: params
  })
}

/**
 * 查询店铺所有VIP卡
 */
export function selectVIPCard(params) {
  return request({
    url: '/admin/store/selectVIPCard',
    method: 'get',
    params: params
  })
}

//查询门店卡
export function selectCards(params) {
  return request({
    url: '/admin/store/selectCards',
    method: 'get',
    params: params
  })
}

export function queryListStoreLessonCardByLessonIdGET(params) {
  return request({
    url: '/admin/store/queryListStoreLessonCardByLessonId',
    method: 'get',
    params: params
  })
}

/**
 * 查询店铺职位列表
 */
export function selectWorkerPosition(params) {
  return request({
    url: '/admin/store/selectposition',
    method: 'get',
    params: params
  })
}
/**
 * 更新店铺职位列表
 */
export function updateposition(data) {
  return request({
    url: '/admin/store/updateposition',
    method: 'post',
    data:data
  })
}

/**
 * 删除职位列表
 */
export function delWorkerPosition(params) {
  return request({
    url: '/admin/store/delposition',
    method: 'get',
    params: params
  })
}
/**
 * 添加店铺职位列表
 */
export function addposition(data) {
  return request({
    url: '/admin/store/addposition',
    method: 'post',
    data:data
  })
}



/**
 * 查询店铺课程业务类型
 */
export function selectLessonnBusness(params) {
  return request({
    url: '/admin/store/selectLessonnBusness',
    method: 'get',
    params: params
  })
}
/**
 * 更新店铺课程业务类型
 */
export function updateLessonnBusness(params) {
  return request({
    url: '/admin/store/updateLessonnBusness',
    method: 'get',
    params: params
  })
}


//店铺所有树形结构菜单
export function qlStoreMenuTree(params) {
  return request({
    url: '/ums/admin/qlStoreMenuTree',
    method: 'get',
    params: params
  })
}

//店铺店员的权限菜单
export function qlAdminMenu(params) {
  return request({
    url: '/ums/admin/qlAdminMenu',
    method: 'get',
    params: params
  })
}
//添加菜单
export function allocAdminMenu(data) {
  return request({
    url: '/ums/admin/allocMenu',
    method: 'post',
    data:data
  })
}

//关键字查询门店列表
export function findByKeyword(params) {
  return request({
    url: '/admin/store/findByKeyWord',
    method: 'get',
    params: params
  })
}

//门店首页数据
export function getHomeData(params) {
  return request({
    url: '/admin/store/getHomeData',
    method: 'get',
    params: params
  })
}


//修改手机号之前获取数据
export function prepareChangePhone(params) {
  return request({
    url: '/admin/store/prepareChangePhone',
    method: 'get',
    params: params
  })
}
//修改手机号
export function changeVipPhone(data){
  return request({
    url: '/admin/store/changeVipPhone',
    method: 'post',
    data: data
  })
}

//查询修改手机号记录
export function searchChangePhone(params) {
  return request({
    url: '/admin/store/searchChangePhone',
    method: 'get',
    params: params
  })
}

//更新店铺全局配置
export function updateSetting(data) {
  return request({
    url: '/admin/store/updateSetting',
    method: 'post',
    data: data
  })
}
//已购买体验卡
export function findCardByUserId(params) {
  return request({
    url: `/admin/bycard/findCardByUserId/${params.storeFrontId}/${params.userId}`,
    method: 'get',
    params: ''
  })
}


// WEBPACK FOOTER //
// ./src/api/storeFront.js